import { render } from "./PlatformBillingPaymentBanner.vue?vue&type=template&id=286e21d5&scoped=true"
import script from "./PlatformBillingPaymentBanner.vue?vue&type=script&lang=js"
export * from "./PlatformBillingPaymentBanner.vue?vue&type=script&lang=js"

import "./PlatformBillingPaymentBanner.vue?vue&type=style&index=0&id=286e21d5&scoped=true&lang=css"
import "./PlatformBillingPaymentBanner.vue?vue&type=style&index=1&id=286e21d5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286e21d5"]])

export default __exports__